export default "__VITE_ASSET__$ExWu$Z8__"